module.exports = __webpack_public_path__ + "img/thumb-006-02.6a30b71d.png";